export class Upload{
    $key: string;
    file:File;
    name:string;
    url:string
    progress:number;
    createAt:Date = new Date()

    constructor(file:File){
        this.file = file
    }
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/entities/upload.ts